import { defineMessages } from 'react-intl';

export default defineMessages({
  description:
    'You must have at least {assetsDeposited} in the Aave Protocol to make use of the swap functionality. This swap functionality only {deposited} in the Aave Protocol.',
  assetsDeposited: 'asset deposited',
  deposited: 'contains the assets you deposited',

  moreInfo: 'For more information on the swap feature, please read the {faq}',

  depositFirst: 'Deposit {number} asset first',

  depositNow: 'Deposit now',
});
